package com.essntl.features.itinerary.ui.edit_itinerary

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalUriHandler
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.contact.ui.ContactState
import com.essntl.features.invoice.ui.allinvoice.InvoiceEvent
import com.essntl.features.invoice.ui.allinvoice.InvoiceState
import com.essntl.features.itinerary.ui.edit_itinerary.components.ItineraryServicesConciergeColumn
import com.essntl.features.itinerary.ui.edit_itinerary.components.ItineraryServicesHeader
import com.essntl.features.itinerary.ui.edit_itinerary.components.ItineraryServicesReorderColumn
import com.essntl.features.itinerary.ui.edit_itinerary.components.SelectServicePopup
import com.essntl.features.proposal.ui.selectservice.SelectServiceEvent
import com.essntl.features.proposal.ui.selectservice.SelectServiceNavigation
import com.essntl.features.proposal.ui.selectservice.SelectServiceState
import com.essntl.features.proposal.ui.selectservice.components.AddEditServicePopup
import com.essntl.features.service.ui.addeditservice.AddEditServiceEvent
import com.essntl.features.service.ui.addeditservice.AddEditServiceState
import com.essntl.features.service.ui.addeditservice.AddEditServiceValidation
import com.essntl.features.supplier.ui.allsuppliers.AllSuppliersEvent
import com.essntl.features.supplier.ui.allsuppliers.AllSuppliersState
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberContains

@Composable
fun EditItineraryScreen(
    isConcierge: Boolean,
    state: EditItineraryState,
    onEvent: (EditItineraryEvent) -> Unit,
    onNavigation: (EditItineraryNavigation) -> Unit,
    contactState: ContactState,
    contactEvent: (ContactEvent) -> Unit,
    addEditServiceState: AddEditServiceState,
    addEditServiceValidation: AddEditServiceValidation,
    addEditServiceEvent: (AddEditServiceEvent) -> Unit,
    selectServiceState: SelectServiceState,
    selectServiceEvent: (SelectServiceEvent) -> Unit,
    allSuppliersState: AllSuppliersState,
    onEventAllSuppliers: (AllSuppliersEvent) -> Unit,
    invoiceState: InvoiceState,
    onInvoiceEvent: (InvoiceEvent) -> Unit,
) {
    var openSelectServiceDialog by rememberSaveable { mutableStateOf(false) }
    var openAddServiceDialog by rememberSaveable { mutableStateOf(false) }

    LaunchedEffect(addEditServiceState.addEditService.isSuccess) {
        if (addEditServiceState.addEditService.isSuccess) {
            addEditServiceState.addEditService.data?.let {
                selectServiceEvent(SelectServiceEvent.AddService(it))
            }
            addEditServiceEvent(AddEditServiceEvent.ClearService)
            openAddServiceDialog = false
        }
    }

    LaunchedEffect(state.addItineraryService.isSuccess) {
        if (state.addItineraryService.isSuccess) {
            openSelectServiceDialog = false
            onEvent(EditItineraryEvent.ClearItineraryService)
        }
    }

    if (!isConcierge) {
        Spacer(modifier = Modifier.height(3.spacing))
    }

    val uriHandler = LocalUriHandler.current

    val selectedItineraryServiceList = rememberContains(
        state.getAllItineraryService.data.orEmpty(),
        state.selectedItineraryServiceIds,
    ) { proposalService -> proposalService.id }

    Column(
        modifier = Modifier.fillMaxSize(),
    ) {
        ItineraryServicesHeader(
            state = state,
            onEvent = onEvent,
            onNavigation = onNavigation,
            onAddServiceClick = { openSelectServiceDialog = true },
            selectedItineraryServiceList = selectedItineraryServiceList,
            isConcierge = isConcierge,
            invoiceState = invoiceState,
            onInvoiceEvent = onInvoiceEvent,
            onShareItineraryClick = { link ->
                uriHandler.openUri(
                    uri = link,
                )
            },
        )

        Spacer(modifier = Modifier.height(1.spacing))

        if (isConcierge)
            ItineraryServicesConciergeColumn(
                state = state,
                onEvent = onEvent,
                onNavigation = onNavigation,
                isConcierge = isConcierge,
            )
        else
            ItineraryServicesReorderColumn(
                state = state,
                onEvent = onEvent,
                onNavigation = onNavigation,
                isConcierge = isConcierge,
            )

        // Todo: Move to the big nav
        SelectServicePopup(
            allSuppliersState = allSuppliersState,
            onEventAllSuppliers = onEventAllSuppliers,
            openDialog = openSelectServiceDialog,
            isLoading = state.addItineraryService.isLoading,
            onDismissRequest = {
                openSelectServiceDialog = false
            },
            state = selectServiceState,
            selectServiceEvent = selectServiceEvent,
            onNavigation = {
                when (it) {
                    is SelectServiceNavigation.AddService -> {
                        openAddServiceDialog = true
                    }

                    is SelectServiceNavigation.ClickService -> {
                        state.getAllItinerary.data?.firstOrNull()?.let { itinerary ->
                            onEvent(
                                EditItineraryEvent.AddItineraryService(
                                    itinerary = itinerary,
                                    service = it.service,
                                ),
                            )
                        }
                    }

                    is SelectServiceNavigation.EditService -> {}
                }
            },
        )

        // Todo: Move to the big nav
        AddEditServicePopup(
            state = addEditServiceState,
            onEvent = addEditServiceEvent,
            validation = addEditServiceValidation,
            openDialog = openAddServiceDialog,
            contactState = contactState,
            contactEvent = contactEvent,
            onDismissRequest = { openAddServiceDialog = false },
        )
    }
}